import * as Yup from 'yup';
export const initialLanguageValues = {
    description: '',
    locale: '',
};
export const languageSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=language.js.map